import { Card, CardContent } from "@/components/ui/card";
import "./index.css";

export function App() {
  return (
    <div 
      className="min-h-screen flex items-center justify-center p-8 relative z-10"
      style={{
        backgroundImage: 'url(/images/background.jpg)',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <Card className="bg-card/50 backdrop-blur-sm border-muted max-w-2xl w-120">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="mb-8">
            <h1 className="text-5xl font-bold mb-4 text-white [text-shadow:3px_3px_0px_#1e3a8a,-1px_-1px_0px_#1e3a8a,1px_-1px_0px_#1e3a8a,-1px_1px_0px_#1e3a8a,0px_0px_15px_rgba(30,58,138,0.8)] [WebkitTextStroke:2px_#1e3a8a]">
              UPWARDBOX
            </h1>
            <div className="w-74 h-1 bg-blue-900 mx-auto mb-8"></div>
          </div>
          
          <div className="mb-8">
            <h3 className="text-3xl font-semibold mb-4 text-white [text-shadow:1px_1px_0px_#000000,-1px_-1px_0px_#000000,1px_-1px_0px_#000000,-1px_1px_0px_#000000,0px_0px_15px_rgba(0,0,0,0.8)] [WebkitTextStroke:5px_#000000]">Página em Construção ...</h3>
            <p className="text-lg text-white mb-6 [text-shadow:1px_1px_0px_#000000,-1px_-1px_0px_#000000,1px_-1px_0px_#000000,-1px_1px_0px_#000000,0px_0px_15px_rgba(0,0,0,0.8)] [WebkitTextStroke:5px_#000000]">
              Estamos trabalhando duro para trazer a melhor experiência de CrossFit para você!
            </p>
          </div>

          <div className="mb-8">
            <div className="inline-block">
              <img 
                src="/images/workout-gym.gif" 
                alt="Workout Gym Training" 
                className="w-64 h-48 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>

          <div className="text-sm text-gray-900">
            <p>Em breve: Treinos, Pilates, e muito mais para você!</p>
            <p className="mt-2">💪 🏋️‍♀️ 🚀</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
